import _JSXStyle from "styled-jsx/style";
import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
export const NoticeBoxMessage = _ref => {
  let {
    children,
    dataTest
  } = _ref;

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["3568970766", [colors.grey900]]])
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3568970766",
    dynamic: [colors.grey900]
  }, ["div.__jsx-style-dynamic-selector{color:".concat(colors.grey900, ";font-size:14px;line-height:19px;}")]));
};
NoticeBoxMessage.propTypes = {
  dataTest: PropTypes.string.isRequired,
  children: PropTypes.node
};